import React, { Component, Fragment } from 'react';
import { Card, Row, Col, } from 'reactstrap';
import "moment/locale/es";
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import ClinicNotesHistoryComplete from './ClinicNotesHistoryComplete';
import { calculateAgeParse } from '../../../Utils/Patient';

class ViewClinicHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pacient: {},
            admissions: [],
            notes: [],
            loading: true,
            age: '',
            date: '',
            useRecomentarions: ''
        }
    }

    componentDidMount() {
        this.getClinicHistory();
    }

    calculateAge = (birthday) => {
        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
        let nacimiento = moment(birthday).format("YYYY-MM-DD");
        this.setState({ age: fecha, date: nacimiento });
    }

    getClinicHistory = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + this.props.data.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                this.calculateAge(data.paciente.fec_nacimiento);
                this.filterData(data.admisiones)
                this.setState({ pacient: data.paciente });

            })
            .catch((error) => {
                alert(error);
                console.error('Error:', error);
            });
    }

    filterData = (data) => {

        //let mainData = [];

        //for (let obj of data) {   
        /*for (let i = (data.length - 1); i >= 0; i--) {
            //
            if (typeof data[i].anamnesis !== 'undefined' && typeof data[i].antecedentes !== 'undefined' && typeof data[i].fisico !== 'undefined' && typeof data[i].plan !== 'undefined') {
                mainData.push(data[i]);
            }
        }*/

        //console.log(mainData);
        this.setState({ admissions: data, loading: false });
    }

    render() {


        return (

            <Card style={{ height: '600px', overflowY: 'scroll', overflowX: 'hidden' }}>
                <Col>
                    {this.state.loading ?
                        <div className="text-center">
                            <Spinner animation="border" variant="success" />
                        </div> :
                        <div style={{ border: '1px solid #CACDD1', borderRadius: 5, padding: 5 }}>
                            <h4 style={{ marginBottom: 20 }} >Paciente</h4>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Nombre: </b> {this.state.pacient.nombres}  {this.state.pacient.apellido1}  {this.state.pacient.apellido2} </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Documento: </b> {this.state.pacient.tip_documento}-{this.state.pacient.num_documento}</h5>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Fecha de Nacimiento: </b> {this.state.date}   </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b>  Edad: </b> {calculateAgeParse(this.state.date)}</h5>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Genero: </b> {this.state.pacient.sexo}   </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b>  Tipo de Sangre: </b> {this.state.pacient.tipo_sangre}</h5>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }

                    {this.state.admissions.map((dataAdmision, index) => {

                        return (
                            <div key={index} style={{ border: '1px solid #CACDD1', borderRadius: 5, padding: 5 }} >


                                <h4 style={{ marginTop: 10 }} > <b> Fecha admision </b> {moment(dataAdmision.fecha).format("LL")} </h4>

                                <hr />

                                {typeof dataAdmision.anamnesis !== 'undefined' ?
                                    <Fragment>

                                        <h4 style={{ marginTop: 20 }} >Anamesis</h4>

                                        <hr />

                                        <Row style={{ marginBottom: 30 }}>
                                            <Col md={6} sm={12}>
                                                <h5> <b> Motivo de Consulta: </b> {dataAdmision.anamnesis.motivo_consulta}  </h5>
                                            </Col>
                                            <Col md={6} sm={12}>
                                                <h5> <b>  Enfermedad Actual: </b> {dataAdmision.anamnesis.enfermedad_actual} </h5>
                                            </Col>
                                        </Row>
                                        <hr />
                                    </Fragment> : null}


                                {typeof dataAdmision.antecedentes !== 'undefined' ?
                                    <Fragment>
                                        <h4 style={{ marginTop: 20 }} >Antecedentes Personales</h4>
                                        <hr />
                                        <h5 style={{ marginTop: 10 }} ><b>Patologicos</b></h5>

                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].cancer != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].cancer != null ?
                                                    <Col >
                                                        <h5> <b> Cancer: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].cancer.value}  </h5>
                                                    </Col> : null
                                            }

                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].diabetes != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].diabetes != null ?
                                                    <Col >
                                                        <h5> <b> Diabetes: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].diabetes.value}  </h5>
                                                    </Col>
                                                    : null
                                            }

                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].enf_coronaria != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].enf_coronaria != null ?
                                                    <Col >
                                                        <h5> <b>  Enf Coronaria: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].enf_coronaria.value} </h5>
                                                    </Col>
                                                    : null
                                            }
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].hepatitis != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].hepatitis != null ?
                                                    <Col >
                                                        <h5> <b> Hepatitis: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].hepatitis.value}  </h5>
                                                    </Col>
                                                    : null
                                            }

                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].transfusiones != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].transfusiones != null ?
                                                    <Col >
                                                        <h5> <b> Hepatitis: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].transfusiones.value}  </h5>
                                                    </Col>
                                                    : null
                                            }

                                            {
                                                dataAdmision.antecedentes.patologicos.patologicos[0].enf_vascular_periferica != undefined && dataAdmision.antecedentes.patologicos.patologicos[0].enf_vascular_periferica != null ?
                                                    <Col >
                                                        <h5> <b>  Enf Vascular Periferica: </b> {dataAdmision.antecedentes.patologicos.patologicos[0].enf_vascular_periferica.value} </h5>
                                                    </Col>
                                                    : null
                                            }
                                        </Row>
                                        <Row style={{ marginTop: 50 }}>

                                            {
                                                dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico != undefined && dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico != null ?
                                                    <Col xs="3">
                                                        <h5> <b> Quirurgicos: </b> {dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.value}  </h5>
                                                    </Col> : null
                                            }




                                            <Col >
                                                {typeof dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.table !== 'undefined' ?
                                                    <table className="table table--bordered">
                                                        <thead>
                                                            <tr>
                                                                <td >Tipo  </td>
                                                                <td >Nombre</td>
                                                                <td >Fecha </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.table.map((data, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{data.tipo}</td>
                                                                        <td>{data.nombre}</td>
                                                                        <td>{data.fecha}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table> :
                                                    <h5> {dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.comentario}  </h5>}
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 50 }}>
                                            <Col xs="3" >
                                                <h5> <b> Farmacológicos: </b> {dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.value}  </h5>
                                            </Col>
                                            <Col >
                                                {typeof dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.table !== 'undefined' ?

                                                    <table className="table table--bordered">
                                                        <thead>
                                                            <tr>
                                                                <td >Principio Activo  </td>
                                                                <td >Fecha Inicio </td>
                                                                <td >Fecha Fin </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.table.map((data, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{data.principioactivo + " " + data.concentracion}</td>
                                                                        <td>{data.fecha_inico}</td>
                                                                        <td>{data.fecha_fin}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    : ""}
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 50 }}>
                                            <Col xs="3" >
                                                <h5> <b>  Inmunizaciones: </b> {dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.value} </h5>
                                            </Col>
                                            <Col >
                                                {typeof dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.table !== 'undefined' ?
                                                    <table className="table table--bordered">
                                                        <thead>
                                                            <tr>
                                                                <td >Vacuna </td>
                                                                <td >Fecha </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.table.map((data, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{data.vacuna}</td>
                                                                        <td>{data.fecha}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    : ""}
                                            </Col>
                                        </Row>
                                        <hr />
                                        <h4 style={{ marginTop: 20, }} > Antecedentes Familiares</h4>
                                        <hr />
                                        <Row xs="3" style={{ marginTop: 10, }}>
                                            <Col >
                                                <h5> <b> Cancer: </b> {dataAdmision.antecedentes.familiares.familiares[0].cancer.value}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Diabetes: </b> {dataAdmision.antecedentes.familiares.familiares[0].diabetes.value}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b>  Enf Coronaria: </b> {dataAdmision.antecedentes.familiares.familiares[0].enf_coronaria.value} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10, marginBottom: 30 }}>
                                            <Col >
                                                <h5> <b> Hipertension: </b> {dataAdmision.antecedentes.familiares.familiares[0].hipertension.value}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Muerte Subita: </b> {dataAdmision.antecedentes.familiares.familiares[0].muerte_subita.value}  </h5>
                                            </Col>
                                            <Col >

                                            </Col>
                                        </Row>
                                        <hr />
                                        <h4 style={{ marginTop: 20 }} > Antecedentes Habitos</h4>
                                        <hr />

                                        <Row xs="3" style={{ marginTop: 20 }}>
                                            <Col >
                                                <h5> <b> Fumador: </b> {dataAdmision.antecedentes.habitos.habitos[0].fumador}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Paquetes / año </b> {dataAdmision.antecedentes.habitos.habitos[0].paquetes_anio}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b>  Año de inicio: </b> {dataAdmision.antecedentes.habitos.habitos[0].ano_inicio} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 20 }}>
                                            <Col >
                                                <h5> <b> Consumo de Alcohol: </b> {dataAdmision.antecedentes.habitos.habitos[0].alcohol}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Frecuencia: </b> {dataAdmision.antecedentes.habitos.habitos[0].alcohol_frecuencia}  </h5>
                                            </Col>

                                        </Row>
                                        <Row xs="3" style={{ marginTop: 20, marginBottom: 30 }}>
                                            <Col >
                                                <h5> <b> Sustancias Psicoactivas: </b> {dataAdmision.antecedentes.habitos.habitos[0].sustancia_psico}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Frecuencia: </b> {dataAdmision.antecedentes.habitos.habitos[0].sustancia_frecuencia}  </h5>
                                            </Col>

                                        </Row>
                                    </Fragment> : null}

                                {typeof dataAdmision.tratamiento !== 'undefined' ?
                                    <Fragment>

                                        {dataAdmision.tratamiento.ordenes.ordenes.addedDiagnostics.length > 0 ?
                                            <Fragment>
                                                <hr />
                                                <h4 style={{ marginTop: 20 }} > Procedimeintos</h4>
                                                <hr />
                                                <Row style={{ marginTop: 10, marginBottom: 30 }}>
                                                    <table className="table table--bordered" >
                                                        <thead>
                                                            <tr>
                                                                <td >Codigo  </td>
                                                                <td >Nombre </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.tratamiento.ordenes.ordenes.addedDiagnostics.map((orden, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{orden.cupscod}</td>
                                                                        <td>{orden.cupsnom}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </Row>
                                                <hr />
                                            </Fragment>
                                            : null
                                        }
                                    </Fragment> : null}

                                {typeof dataAdmision.fisico !== 'undefined' ?
                                    <Fragment>
                                        <h4 style={{ marginTop: 20 }} > Examen Físico</h4>
                                        <hr />
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b> Peso: </b> {dataAdmision.fisico.peso + " (kg)"}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Talla: </b> {dataAdmision.fisico.talla}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Superficie Corporal: </b> {dataAdmision.fisico.superficie_corporal + ' (mc)'} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b> Índice de Masa Corporal: </b> {dataAdmision.fisico.masa_corporal}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Frecuencia Cardiaca: </b> {dataAdmision.fisico.frecuencia_cardiaca + ' (lpm)'}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Frecuencia Respiratoria: </b> {dataAdmision.fisico.frecuencia_respiratoria + ' (resp/min)'} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b>Presiona Arterial: </b> {dataAdmision.fisico.presion_arterial + ' (mm/Hg)'}  </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 25 }}>
                                            <Col >
                                                <h5> <b>Aspecto General: </b> {dataAdmision.fisico.aspecto_general}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Cabeza y Cara: </b> {dataAdmision.fisico.cabeza_cara}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Otorino: </b> {dataAdmision.fisico.otorrino} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b>Ojos: </b> {dataAdmision.fisico.ojos}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Cuello: </b> {dataAdmision.fisico.cuello}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Torax: </b> {dataAdmision.fisico.torax} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b>Cardiovascular: </b> {dataAdmision.fisico.cardiovascular}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Pulmonar: </b> {dataAdmision.fisico.pulmonar}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Abdomen: </b> {dataAdmision.fisico.abdomen} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10 }}>
                                            <Col >
                                                <h5> <b>Extremidades: </b> {dataAdmision.fisico.extremidades}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Neurologico: </b> {dataAdmision.fisico.neurologico}  </h5>
                                            </Col>
                                            <Col >
                                                <h5> <b> Genitourinatio: </b> {dataAdmision.fisico.genitourinario} </h5>
                                            </Col>
                                        </Row>
                                        <Row xs="3" style={{ marginTop: 10, marginBottom: 30 }}>
                                            <Col >
                                                <h5> <b>Piel y Fanareas: </b> {dataAdmision.fisico.piel_faneras}  </h5>
                                            </Col>
                                        </Row>
                                    </Fragment> : null}

                                {typeof dataAdmision.diagnostico !== 'undefined' ?

                                    <Fragment>
                                        {dataAdmision.diagnostico.diagnostico.diagnostico.length > 0 ?
                                            <Fragment>
                                                <hr />
                                                <h4 style={{ marginTop: 20, marginBottom: 20 }} > Diagnosticos</h4>
                                                <hr />
                                                <Row style={{ marginTop: 10 }}>
                                                    <table className="table table--bordered" >
                                                        <thead>
                                                            <tr>
                                                                <td >Código  </td>
                                                                <td >Nombre </td>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.diagnostico.diagnostico.diagnostico.map((diagnostico, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td> {diagnostico.codigo}</td>
                                                                        <td> {diagnostico.nombre}</td>
                                                                    </tr>

                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </Row>
                                            </Fragment>
                                            : null}
                                    </Fragment> : null}

                                {typeof dataAdmision.tratamiento !== 'undefined' ?

                                    <Fragment>

                                        {dataAdmision.tratamiento.tratamiento.tratamiento.length > 0 ?
                                            <Fragment>
                                                <hr />
                                                <h4 style={{ marginTop: 20, marginBottom: 10 }} > Ordenes Medicas</h4>
                                                <hr />
                                                <Row style={{ marginTop: 10 }}>
                                                    <table className="table table--bordered" >
                                                        <thead>
                                                            <tr>
                                                                <td >Principio Activo  </td>
                                                                <td >Vía de Administración </td>
                                                                <td >Frecuencia </td>
                                                                <td >Dosis </td>
                                                                <td >Duracion </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataAdmision.tratamiento.tratamiento.tratamiento.map((orden, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td> {orden.principio_activo + " " + orden.concentracion}</td>
                                                                        <td> {orden.via_administracion}</td>
                                                                        <td> {orden.frecuencia}</td>
                                                                        <td> {orden.dosis}</td>
                                                                        <td> {orden.duracion + " días"}</td>
                                                                    </tr>

                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </Row>
                                            </Fragment>
                                            : null
                                        }
                                    </Fragment> : null}

                                {typeof dataAdmision.notas_clinicas !== 'undefined' ?
                                    <ClinicNotesHistoryComplete notas_clinicas={dataAdmision.notas_clinicas} /> : null}
                                <h4 style={{ marginTop: 80 }} > Médico Tratante</h4>
                                <Row style={{ marginTop: 10, marginBottom: 30 }}>
                                    <Col >
                                        <h5> <b> {dataAdmision.nombres + " " + dataAdmision.apellido1} </b> </h5>
                                        <h5> <b> {dataAdmision.especialidad}  </b></h5>
                                        <h5> <b> {dataAdmision.reg_medico}  </b></h5>
                                    </Col>
                                </Row>
                            </div>
                        );
                    })
                    }
                </Col>
            </Card>
        );
    }
}

export default ViewClinicHistory;
